import React, { useState } from 'react';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import AIRichText from 'components/AIRichText';
import { EAIRichTextEditorType } from 'types/ai';
import s from './s.module.less';

type Props = {
    value: string;
    onChange: (val: string) => void;
    businessId: number;
    isTextVisit?: boolean;
    // 渲染在卡片边框内底部的操作区（会中场景的 Save 按钮）
    footer?: React.ReactNode;
};

const BillingNote = ({ value, onChange, businessId, isTextVisit, footer }: Props) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={s.wrap}>
            <div className={s.header}>
                <div className={s.titleRow}>
                    <h4 className={s.title}>
                        Notes for the Klarity billing team <span className={s.optional}>(optional)</span>
                    </h4>
                </div>
                <span className={s.expandIcon} onClick={() => setExpanded(!expanded)}>
                    {expanded ? <UpOutlined /> : <DownOutlined />}
                </span>
            </div>
            {expanded && (
                <div className={s.subtitle}>Add anything the Klarity billing team should know about this claim.</div>
            )}
            {expanded && (
                <AIRichText
                    value={value}
                    onChange={onChange}
                    relationId={businessId}
                    placeholder="Write down anything the Klarity billing team should know about this claim..."
                    type={
                        isTextVisit
                            ? EAIRichTextEditorType.TEXT_VISIT_NOTE_FOR_PROVIDER
                            : EAIRichTextEditorType.AI_EDITOR_APPOINTMENT_NOTE_FOR_PROVIDER
                    }
                />
            )}
            {expanded && footer}
        </div>
    );
};

export default BillingNote;
